<div class="stepper"[ngClass]="{'inPreview':isPreview,'inData':isData}">
    <que-step *ngFor="let step of stepsNames,let i = index" (click)="currentStep!=i?changePage(i):null"
        [stepName]="step" [isCurrent]="currentStep==i" [index]="i" [isPreview]="isPreview || isData"  [isData]="isData"></que-step>
</div>